import React, { useState, useEffect } from 'react';
import { get } from '../common/httpService';
import common from '../common/common';

function QuickCart(props) {
    const [quickCartData, setQuickCartData] = useState({
        cartStep1Url: '',
        productsNumber: 0,
    });

    async function getQuickCartData() {
        try {
            get({
                url: `cart/getQuickCartData`,
            }).then((data) => {
                setQuickCartData(data);
            });
        } catch (e) {
            console.log(e.status);
        }
    }

    useEffect(() => {
        getQuickCartData();
    }, []);

    return (
        <a
            href={common.getSiteUrl(quickCartData.cartStep1Url)}
            className={`carticon ${
                quickCartData.productsNumber > 0 ? 'badge' : ''
            }`.trim()}
            data-badge={quickCartData.productsNumber}
            name='carticon'>
            <img
                src={common.contentFromCdn({
                    path: `/content/img/shopping-cart.svg`,
                    keepUrlAsIs: false,
                })}
                type='image/svg+xml'
                alt='shopping cart'
            />
        </a>
    );
}

export default QuickCart;
